import React from "react";
import { OrderedMap } from "immutable";
import { Row, Col, Card, Button, message, Modal } from "antd";
import PropTypes from "prop-types";
import { Table } from "components";
import { ASSESSMENT_COLS, ASSESSMENT_CAM_DETAILS_COLS } from "constants/table-columns";
import CaseService from "services/case-service";
import CompanyService from "../../services/company-service";

const onCellGenerator = (handleSave, _) => record => ({
    record,
    // editable: true,
    editable: record.deviation === "Yes" || (record.deviation === "No" && record.remarks !== "--" && (record.remarks !== null || record.remarks.length >= 0)) ? true : false,
    dataIndex: _.dataIndex,
    title: record.header || _.title,
    handleSave,
    rules: record.rules || _.rules,
    fieldType: record.fieldType || _.fieldType,
    filesMultiple: _.filesMultiple ? _.filesMultiple : false,
    options: record.options || _.options,
    getFileUploadParams: _.getFileUploadParams,
    uploadTarget: _.uploadTarget,
    viewable: _.viewable,
    max: record.max
});

class AssessmentReviewReport extends React.Component {
    state = {
        originalResponse: {},
        originalCamData: {},
        newData: new OrderedMap({}),
        loading: false,
        camData: new OrderedMap({}),
        camModal: false,
        camDetailsData: new OrderedMap({}),
        lenderName: "",
    };

    componentDidMount() {
        CompanyService.cibilCommercialParam(this.props.caseId).then(_ => {
            CaseService.getCreditAssessment(this.props.caseId).then(res => {
                this.setState({
                    originalResponse: res.data,
                    newData: res.data && new OrderedMap(res.data.data),
                });
            }).catch(() => {});
        }).catch(err => {
            console.log("err", err);
        })
        // this.getLendersCam();
        
    }
    updateDetails = () => {
        let data = {
            ...this.state.originalResponse,
            data: this.state.newData && this.state.newData.toJS()
        };
        CaseService.updateCreditAssessment(this.props.caseId, data).then(() => {
            message.success("Assessment Report Updated");
        }).catch(() => {
            message.error("Failed to update Assessment Report");
        });
    }

    handleSaveMultipleEntries = (record, values) => {
        if(record.key && this.state.newData.size) {
            let data = this.state.newData.map((_, k) => {
                if(k == record.key) {
                    return {
                        ..._,
                        ...values,
                        key: record.key
                    };
                }
                return _;
            });
            this.setState({
                newData: data
            });
        }
    }

    refreshDetails = () => {
        CaseService.refreshCreditAssessmentData(this.props.caseId).then((res) => {
            this.setState({
                originalResponse: res.data,
                newData: res.data && new OrderedMap(res.data.data),
                loading: false
            });
        }).catch(() => {});
    }

    loadTable = () => {
        this.setState({
            loading: true,
            originalResponse: {},
            newData: new OrderedMap({}),
        }, () => this.refreshDetails());
    }

    getLendersCam = () => {
        this.setState({
            loading: true
        });
        CaseService.getLendersCam(this.props.caseId).then(res => {
            this.setState({
                originalCamData: res.data.results,
                camData: res.data.results,
                loading: false
            });
        });
    }

    postLendersCam = () => {
        CaseService.postLendersCam(this.props.caseId).then(() => {
            message.success("Executed successfuly");
            this.getLendersCam();
        });
    }

    closeModal = () => {
        this.setState({
            camModal: false
        });
    }

    viewCamDetails = (a, record, c) => {
        console.log(a,c);
        this.setState({
            loading: true
        });
        CaseService.getSingleLendersCam(this.props.caseId, record.id).then(res => {
            this.setState({
                camDetailsData: new OrderedMap(res.data.results[0].cam_json),
                loading: false
            });
        });
        this.setState({
            camModal: true,
            lenderName: record.bank.name
        });
    }

    TableCellClick = (clickHandler, label) => (columnValue, record) => {
        return (<a onClick={clickHandler.bind(record, columnValue, record)}>{label}</a>);
    }

    render() {

        // var CAM_COLS = ASSESSMENT_CAM_COLS;

        // CAM_COLS = CAM_COLS.map((col, key) => {
        //     if(key === "action"){
        //         return Object.assign({
        //             render: this.TableCellClick(this.viewCamDetails, "View CAM")
        //         }, col);
        //     }
        //     return col;
        // });
        const bankCodeCIFCL = ["CIFCL", "MF"].includes(this.props.caseDetail?.bank?.code);
        let supplyChainAnchorZetwerk = this.props.caseDetail?.supply_chains.find(el=>el.anchor.name === "Zetwerk Manufacturing Businesses Private Limited" || el.anchor.name ==="Hella Infra Market Private Limited");
        const cifcl_data_labels = ["Tranche Tenure", "Limit Tenure", "Co-Applicant", "Constitution of Customer", "RC Facility Amt. Sanction Amt.", "CMR/MSME rank greater than 8 (Commercial Cibil)", "Written-off, Suit filed, Settled, Willful defaulter within last 2 years (excluding CC)(Commercial Cibil)", "SMA 2 in last 6 months (CC)(Commercial Cibil)"];
        const cifcl_render_data = this.state.newData.filter(_=> cifcl_data_labels.includes(_?.label) && _.visible);
        const render_data = bankCodeCIFCL && supplyChainAnchorZetwerk !== undefined ? cifcl_render_data : this.state.newData.filter(_ => _ && _.visible);
        return (
            <React.Fragment>
                <Modal
                    title={this.state.lenderName}
                    visible={this.state.camModal}
                    footer={null}
                    onCancel={this.closeModal}
                    width={800}
                >
                    <Table
                        columns={ASSESSMENT_CAM_DETAILS_COLS.map(({ editable, ...restColFields}) => {
                            if (!onCellGenerator || !editable) {
                                return { ...restColFields };
                            }
                            return {
                                onCell: onCellGenerator(
                                    this.handleSaveMultipleEntries,
                                    restColFields
                                ),
                                ...restColFields
                            };
                        })}
                        loading={this.state.loading}
                        data={this.state.camDetailsData.filter(_ => _ && _.visible).map((_, k) => {
                            let row = _;
                            if(row && typeof row === "object") {
                                row.key = k;
                                row.sno = _.sno;
                                row.value = _.value;
                                row.review_category = _.deviation === "No" ? _.review_category || "OK" : _.review_category;
                                row.remarks = _.deviation === "No"  ? _.remarks || "--" : _.remarks;
                            }
                            return row;
                        }).toList().sort((a, b) => {
                            if((a && a.sno) > (b && b.sno))
                                return 1;
                            return -1;
                        })}
                        showTopSection={false}
                        editable={false}
                        noRowSelection={true}
                        pagination={false}
                    />
                </Modal>
                {/* <Row className={"p-10"}>
                    <Col span={24}>
                        <Card title={"CAM Output"} className={"padless-card"} extra={[
                            !this.state.camData || this.state.camData.length === 0 ? 
                                <Button type={"link"} onClick={this.postLendersCam} key="get-lenders-cam">
                                    Get Lenders CAM
                                </Button>
                                : null
                        ]}>
                            <Table
                                columns={CAM_COLS}
                                data={(new List(this.state.camData) || new List([])).map(_ => {
                                    return _;
                                })}
                                showTopSection={false}
                                loading={this.state.loading}
                                editable={false}
                                noRowSelection={true}
                                pagination={false}
                            />
                        </Card>
                    </Col>
                </Row> */}
                <Row className={"p-10"}>
                    <Col span={24}>
                        <Card title={"Credit Assessment Review"} className={"padless-card"} extra={[
                            <Button type={"link"} onClick={this.loadTable} key="refresh">
                                Refresh
                            </Button>,
                            <Button type={"link"} onClick={this.updateDetails} key="update"
                                disabled={this.props.recreditViewOnlyPermission}
                            >
                                Update 
                            </Button>
                        ]}>
                            <Table
                                columns={ASSESSMENT_COLS.map(({ editable, ...restColFields}) => {
                                    if (!onCellGenerator || !editable) {
                                        return { ...restColFields };
                                    }
                                    return {
                                        onCell: onCellGenerator(
                                            this.handleSaveMultipleEntries,
                                            restColFields
                                        ),
                                        ...restColFields
                                    };
                                })}
                                loading={this.state.loading}
                                data={render_data.map((_, k) => {
                                    let row = _;
                                    if(row && typeof row === "object") {
                                        row.key = k;
                                        row.sno = _.sno;
                                        row.value = _.value;
                                        row.review_category = _.deviation === "No" ? _.review_category || "OK" : _.review_category;
                                        row.remarks = _.deviation === "No"  ? _.remarks || "--" : _.remarks;
                                    }
                                    return row;
                                }).toList().sort((a, b) => {
                                    if((a && a.sno) > (b && b.sno))
                                        return 1;
                                    return -1;
                                })}
                                showTopSection={false}
                                editable={true}
                                noRowSelection={true}
                                pagination={false}
                            />
                        </Card>
                    </Col>
                </Row>
            </React.Fragment>
        );
    }

}

AssessmentReviewReport.propTypes = {
    caseId: PropTypes.number,
    bank: PropTypes.string,
    caseDetail: PropTypes.object,
    recreditViewOnlyPermission: PropTypes.bool,
};

export default (AssessmentReviewReport);